import React from "react";
import { Field, useFormState } from "react-final-form";

import { NavigationButton } from "../components/NavigationButton";
import { FormData, FormResources } from "../types/formData";
import { Navigation } from "../types/navigation";
import { RadioButtonsContainer } from "../valuation-manager.styles";

interface Props {
  setPageName: (pageName: Navigation) => void;
  formResources: FormResources;
}

export const ModificationsPage = ({ setPageName, formResources }: Props) => {
  const { values }: { values: FormData } = useFormState();

  return (
    <div>
      <div className="row">
        <RadioButtonsContainer className="col-sm-12 col-md-12 col-lg-12">
          <legend>{formResources.modifications.title}</legend>
          {formResources.modifications.options.map((option) => (
            <div className="radio" key={option.value}>
              <label>
                <Field
                  name="modifications"
                  component="input"
                  type="radio"
                  value={option.value}
                  required
                />
                {option.label}
              </label>
            </div>
          ))}

          <Field name="modifications" subscription={{ value: true }}>
            {({ input: { value } }) =>
              value === "yes" ? (
                <div className="form-group">
                  <label>
                    Modification details:&nbsp;
                    <Field
                      component="textarea"
                      name="modifcationDetails"
                      rows={7}
                      cols={100}
                      minLength={25}
                      required={values.modifications === "yes"}
                      className="form-control"
                      data-testid="modifications-textarea"
                    />
                  </label>
                </div>
              ) : null
            }
          </Field>
        </RadioButtonsContainer>
      </div>
      <NavigationButton setPageName={setPageName} disabled={!values.modifications} />
    </div>
  );
};
